import { render, staticRenderFns } from "./SubjectEnrollment.vue?vue&type=template&id=b1218606&"
import script from "./SubjectEnrollment.vue?vue&type=script&lang=js&"
export * from "./SubjectEnrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports